import React from 'react';
import Container from '../../../components/Container';
import useForm from '../../../hooks/useForm';
import {Item, Image, ContainerItem, ItemInfo, Upload, DsFlex, Empty, Document, CroppieI, LabelI} from './styled';
import {GrEdit} from 'react-icons/gr';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {RiDeleteBin5Line} from 'react-icons/ri';
import { createStyles, Theme, withStyles, WithStyles, useTheme, makeStyles } from '@material-ui/core/styles';
import { Button, DialogContentText, IconButton } from '@material-ui/core';
import Input from '../../../components/Form/Input';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import SpeedDial from '@material-ui/lab/SpeedDial';
import ListIcon from '@material-ui/icons/List';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { FaCamera } from 'react-icons/fa';
import {AiFillEye} from 'react-icons/ai';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import TimerIcon from '@material-ui/icons/Timer';
import {default as AlertMaterialUI} from '@material-ui/lab/Alert';
import Alert from '../../../components/Alert';
import DoneIcon from '@material-ui/icons/Done';
import { useNavigate, useParams } from 'react-router';
import { api } from '../../../services/api';
import moment from 'moment';
import { UserContext } from '../../../UserContext';
import { CgMaximize } from 'react-icons/cg';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Pagination, Skeleton } from '@material-ui/lab';
import { Hr } from '../../Register/styled';
import Select from '../../../components/Form/Select';
import NumberFormat from 'react-number-format';
import { Label } from '../../../components/Form/Input/styled';
import ClearIcon from '@material-ui/icons/Clear';
import { Header } from '../../Repository/Show/styled';
import { Canhoto, CanhotosProps, FilialProp } from '../../../interfaces';
import Modal from '../../../components/Modal';
import { Tooltip } from '@material-ui/core';
import AddAPhoto from '@material-ui/icons/AddAPhoto';

//IMPORT DO CROPPIE
import Croppie from "croppie";
import "croppie/croppie.css";
import { cursorTo } from 'readline';

function AlertDark(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
});

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({   
        rootSpeed: {
            height: '100vh',
            width: '100%',
            position: 'fixed',
            top: 0,
            left: 0,
            transform: 'translateZ(0px)',
            flexGrow: 1,
            zIndex: 999,
        },
        button: {

        },
        speedDial: {
            bottom: theme.spacing(4),
            right: theme.spacing(4),
            position: 'fixed',
            zIndex: 999
        },
        root: {
            display: 'flex',
            justifyContent: 'center',
            '& > * + *': {
              marginTop: theme.spacing(2),
            },
        },
        '.MuiAlert-message': {
            padding: 0
        }
    }),    
);

const tipoConhecimento = [
    {id: 1, description: 'Entrega'},
    {id: 2, description: 'Devolução'},
    {id: 3, description: 'Reentrega'},
    {id: 4, description: 'Cliente'},
    {id: 5, description: 'Redespacho'},
    {id: 6, description: 'Transbordo'},
    {id: 7, description: 'Transferência'}
];

const tipoDocumento = [
    {id: 1, description: 'Nossa NF'},
    {id: 2, description: 'NF Cliente'},
    {id: 3, description: 'NF Fornecedor'},
];

export function currencyFormatter(value: any) {
    if (!Number(value)) return "";
  
    const amount = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(value / 100);
  
    return `${amount}`;
}

export function removeAllChildNodes(parent: any) {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
}

const Anexar: React.FC = () => {
    document.title = "Controle de Frete - Sultan Veste a Casa";
    
    const {setLoading, loading} = React.useContext(UserContext);

    const [open, setOpen] = React.useState(false);
    const [openAdd, setOpenAdd] = React.useState(false);
    const [openSend, setOpenSend] = React.useState(false);
    const [openView, setOpenView] = React.useState(false);
    const [openImage, setOpenImage] = React.useState(false);
    const [openConfirm, setOpenConfirm] = React.useState(false);
    const [openConfirmCode, setOpenConfirmCode] = React.useState(false);
    const [confirmBack, setConfirmBack] = React.useState(false);
    const [image, setImage] = React.useState<string | ArrayBuffer | null>();
    const [success, setSuccess] = React.useState('');
    const [sendActive, setSendActive] = React.useState(false);
    const [error, setError] = React.useState('');
    const [openSpeed, setOpenSpeed] = React.useState(false);
    const [canhoto, setSelectCanhoto] = React.useState<Canhoto | null>();
    const [canhotos, setCanhotos] = React.useState<Canhoto[]>([]);
    const [page, setPage] = React.useState(1);
    const [filiais, setFiliais] = React.useState<Array<any>>([]);
    const [documentoPai, setDocumentoPai] = React.useState<CanhotosProps>();

    //INICIO DAS CONST DO COPPIE
    // const [image, setImage] = React.useState("");
    const [blob, setBlob] = React.useState("");
    const [nameImage, setNameImage] = React.useState("");
    const [size, setSize] = React.useState("");
    const [quality, setQuality] = React.useState("7");
    const [croppie, setCroppie] = React.useState<Croppie | null>(null)
    // const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [showCroppie, setShowCroppie] = React.useState(false);
    // const [error, setError] = React.useState("");
    // const [success, setSuccess] = React.useState('');
    //FIM DAS CONST DO CROPPIE

    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const params = useParams();
    const navigate = useNavigate();

    const filial = useForm();
    const numero_nfe = useForm();
    const serie_nfe = useForm();
    const data_entrega = useForm();
    const valor = useForm();
    const tipo_conhecimento = useForm();
    const tipo_documento = useForm();
    const seq_doc = useForm();
    const num_doc = useForm();
    const pk = useForm();
    const timestamp = useForm();
    const imagem = useForm();
    const code_confirm = useForm();

    const inicioPage = page - 1;
    const canhotosPorPagina = 5;

    const tipoDocumentoStr = params.tipo === '1' ? 'CTE' : params.tipo === '2' ? 'Romaneio' : params.tipo === '3' ? 'Serviço' : 'Recibo';

    //INICIO DO CARREGAMENTO DO CROPPIE
    const name = useForm('nameFile');
    
    const LoadCroppie = () => {
        console.log(croppie)
        if(croppie !== null)
        {
            //croppie.destroy()
            //setCroppie(null)
        }
        const el = document.getElementById("image-helper");

        if (el) {
            if(el?.className === "croppie-container"){ return false }
            const croppieInstance = new Croppie(el,{
                // viewport: { width: 100, height: 100 },
                viewport: { width: 300, height: 100 },
                boundary: { width: 300, height: 300 },
                showZoomer: false,
                enableResize: true,
                enableOrientation: true,
                mouseWheelZoom: 'ctrl'

            });
            
            
            setCroppie(croppieInstance);
            
            el.addEventListener("update", (resp) => {
                croppieInstance.result({
                    type: 'canvas',
                    quality: 8,
                    format: 'jpeg',
                    backgroundColor: '#ffffff'
                }).then(function (resp) {
                    let base64Length = resp.length - (resp.indexOf(',') + 1);
                    let padding = (resp.charAt(resp.length - 2) === '=') ? 2 : ((resp.charAt(resp.length - 1) === '=') ? 1 : 0);
                    // let fileSize = base64Length * 0.75 - padding;

                    // setSize(formatBytes(fileSize, 1));
                });
                // console.log(fileSize)
            });
            
        }
    };
    //FIM DO CARREGAMENTO DO CROPPIE
        
    const checkCroppie = React.useCallback(() => {
        if(croppie === null)
        {
            console.log('LOAD!')
            //LoadCroppie();
        }
    }, []);
    // INICIO DO LOADCROPPIE
        React.useEffect(() => {
            //LoadCroppie();
            // eslint-disable-next-line
        }, []);
    //FIM DO LOADCROPPIE

    //INICIO HANDLE CROPPIE

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const LightTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: 11,
            padding: '20px'
        },
    }))(Tooltip);

    const handleOpenImage = () => {
        if (croppie !== null) {
            croppie.result({
                type: 'canvas',
                quality: 7,
                format: 'jpeg',
                backgroundColor: '#ffffff'
            }).then((blob) => {
                setBlob(blob);
            })
            console.log(blob)
        }
        //setOpen(true);
    };

    const handleImage = (image: string) => {
        //setImage(image);
        //LoadCroppie();
        console.log(croppie, 'handleImage',image)
        if (croppie === null) return;
        
        croppie.bind({
            url: image,
        });

        setShowCroppie(true)
    }

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        if (croppie !== null) {
            const blobResponse = await croppie.result({
                type: 'base64',
                quality: 8,
                size: 'original',
                format: 'jpeg',
                backgroundColor: '#ffffff'
                
            });
//console.log(blobResponse)
//return;
            const target = document.querySelector('input[type="file"]') as HTMLInputElement;
            console.log(target)
            if (!target) return;

            const arquivo: File = (target.files as FileList)[0];
            console.log(arquivo)
            
            const filename = arquivo.name;

            const bodyFormData = new FormData();
            bodyFormData.append('file', arquivo);
            bodyFormData.append('name', filename.split(".")[0]);
            bodyFormData.append('base64', blobResponse);
            console.log(blobResponse);

            let newImage = new Blob([blobResponse]);
            let reader = new FileReader();
            //console.log(newImage)
                reader.readAsText(newImage);

                reader.onload = function () {                
                    setImage(reader.result);
                    imagem.setValue(blobResponse)
                };
           
                //setImage(reader.result)
        }
        
        const container = document.getElementById('image-helper');
        removeAllChildNodes(container);
        setShowCroppie(false)
    }
    //FIM HANDLE COPPIE

    React.useEffect(() => {
        if(params.pk){
            getCanhotos(params.pk);
        }       
        
        if(params.page){
            setPage(parseInt(params.page));
        }

        getFiliais();       
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getFiliais = async () => {
        try{
            const {data} = await api.get('/filial');

            const options = data.filiais.map((item : FilialProp) => {
                return {
                    id: item.sCodigoFilial,
                    description: item.sNomeFantasia + ' - ' + item.sCNPJ
                }
            });

            setFiliais(options);
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }
    }

    const getCanhotos = async (pk: string) => {
        try{
            setLoading(true);   

            const {data} = await api.get(`freight-control/${pk}`);

            setCanhotos(data.canhotos);
            if(data.documentoPai){
                setDocumentoPai(data.documentoPai);
            }
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    const handleOpenSpeedDial = () => {        
        setOpenSpeed(true);
    };

    const situacaoDocument =  async () => {        
        try{
            setLoading(true);

            await api.post('/frete/document/situacao', {
                PKControleDeFrete: params.pk, 
                iSituacaoEnvio: canhotos[0].iSituacaoEnvio === '1' ? '2' : '1', 
                TimeStampControleDeFrete: canhotos[0].TimeStampControleDeFrete,                                
            });
            
            setSuccess('Situação Alterada');
            setSendActive(false);
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setOpenSend(false);
            setLoading(false);

            if(params.pk){
                getCanhotos(params.pk);
            }    
        }
    }

    const handleOptionsSpeedDial = (e: React.MouseEvent, operation: string) => {
        e.preventDefault();
        if(operation === "add"){
            handleClickOpenAdd();
        }else if(operation === "done"){            
            setOpenSend(true);
        }

        handleCloseSpeed();
    }    

    const handleCloseSpeed = () => {
        setOpenSpeed(false);
    };

    const actions = [    
        { 
            icon: canhotos.length > 0 && canhotos[0].iSituacaoEnvio === '1' ? <DoneIcon style={{fill: "#666"}}/> : <ClearIcon style={{fill: "#666"}}/>, 
            name: canhotos.length > 0 && canhotos[0].iSituacaoEnvio === '1' ? 'Finalizar Envio' : 'Cancelar Envio', 
            action: handleOpenSpeedDial, 
            operation: 'done'
        },                   
    ];

    if(params.tipo === '3' || params.tipo === '4'){
        actions.push({ icon: <PostAddIcon style={{fill: "#666"}}/>, name: 'Adicionar Canhoto', action: handleOpenSpeedDial, operation: 'add'});
    }

    const handleClickOpen = (item: Canhoto) => {  
        setImage(null);
        
        code_confirm.setValue('');                 
        tipo_conhecimento.setValue(item.iTipoConhecimento);
        tipo_documento.setValue(item.iTipoDocumento);
        seq_doc.setValue(item.iSeqDoc);
        num_doc.setValue(item.iNumeroDocumento);        
        filial.setValue(item.sFilial);
        numero_nfe.setValue(item.iNumeroNF);
        serie_nfe.setValue(item.sSerie.trim());
        data_entrega.setValue(item.dtDataEntrega);
        valor.setValue(`${parseFloat(item.nValor).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`);    
        imagem.setValue(item.imgDocumento);
        pk.setValue(item.PK);
        timestamp.setValue(item.TimeStamp);

        setOpen(true);
    };

    const handleClickOpenView = (item: Canhoto) => {
        setSelectCanhoto(item);
        setOpenView(true);
    };

    const handleClickOpenImage = (item: Canhoto) => {
        setSelectCanhoto(item);
        setOpenImage(true);
    };

    const handleClickOpenAdd = () => {
        filial.setValue('');
        numero_nfe.setValue('');
        serie_nfe.setValue('');
        data_entrega.setValue('');
        valor.setValue('');
        tipo_conhecimento.setValue('');
        tipo_documento.setValue('');
        seq_doc.setValue('');
        num_doc.setValue('');
        setImage(null);

        setOpenAdd(true);
    };

    const handleClickDelete = () => {
        deleteCanhoto();
        handleCloseConfirmDelete();
    };

    const handleCloseEdit = () => {
        setOpenConfirmCode(true);
    };

    const handleCloseAdd = () => {
        sendCanhoto();                        
    };

    const handleCloseView = () => {
        setOpenView(false);
    }; 
    
    const handleCloseImage = () => {
        setOpenImage(false);
    }; 

    const handleConfirm = (item: Canhoto) => {
        setSelectCanhoto(item);
        imagem.setValue(item.imgDocumento);
        setOpenConfirm(true);
    }

    const handleCloseConfirmDelete = () => {
        setOpenConfirm(false);
        setSelectCanhoto(null);
    }

    const handleConfirmationSendOrCancel = () => {
        setOpenSend(false);
    }
    
    const uploadFile = async (e: any) => {
        //LoadCroppie();

        const target = e.target as HTMLInputElement;
        const file: File = (target.files as FileList)[0];

        if (file) {
            if(file.type !== 'image/jpeg'){
                setError('Envie uma imagem em JPG!');
                return;
            }
            
            var nameFile = file.name.replace(/\.(.*)/g, '');
            nameFile = nameFile.replace(/[^a-zA-Z0-9]/gi, '_');

            setNameImage(nameFile);

            name.setValue(nameFile);

            const base64 = await convertBase64(file);
            handleImage(base64);
        }
    }
/* 
    const handleFileRead = async (e: any) => {
        if (!e.target.files[0]) return;

        const file = e.target.files[0];

        if(file.type !== 'image/jpeg'){
            setError('Envie uma imagem em JPG!');
            return;
        }

        var nameFile = file.name.replace(/\.(.*)/g, '');
        nameFile = nameFile.replace(/[^a-zA-Z0-9]/gi, '_');

        setNameImage(nameFile);

        name.setValue(nameFile);

        const base64 = await convertBase64(file);
        handleImage(base64);
    } */

    const convertBase64 = (file: any) => {
        return new Promise<any>((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',    
    });      

    const handleChangePagination = (event: React.ChangeEvent<unknown>, value: number) => {
        window.history.pushState(`Página ${value}`, `Página ${value}`, `/area-restrita/usuario/controle-de-frete/anexar/${params.tipo}/${params.pktransportadora}/${params.pk}/${value}`);
        setPage(value);
        window.scrollTo({top: 0, behavior: 'smooth'});
    };   

    const sendCanhoto = async () => {    
        try{
            setLoading(true);

            const target = document.querySelector('#send') as HTMLInputElement;
            if (!target) return;

            const arquivo: File = (target.files as FileList)[0];

            const bodyFormData = new FormData();
            bodyFormData.append('file', arquivo);
            bodyFormData.append('PKControleDeFreteMov', '-1');
            bodyFormData.append('TimeStamp', '1');
            bodyFormData.append('Action2Do', '1');
            bodyFormData.append('PKControleDeFrete', params.pk);
            bodyFormData.append('PKTransportadora', params.pktransportadora);
            bodyFormData.append('TipoConhecimento', tipo_conhecimento.value);
            bodyFormData.append('TipoDocumento', tipo_documento.value);
            bodyFormData.append('SeqDoc', seq_doc.value);
            bodyFormData.append('NumeroDocumento', num_doc.value);
            bodyFormData.append('Filial', filial.value);
            bodyFormData.append('NumeroNF', numero_nfe.value);
            bodyFormData.append('Serie', serie_nfe.value);
            bodyFormData.append('DataEntrega', data_entrega.value);

            const cleanValue = valor.value.replace(/[^0-9,]*/g, '').replace(',', '.');
            bodyFormData.append('Valor', cleanValue);

            const headers = {headers: {"Content-Type": "multipart/form-data"}}

            await api.post('/frete/canhoto/save', bodyFormData, headers);

            setSuccess('Inserido com sucesso!');
            setSendActive(true);
            setOpenAdd(false);
            setImage(null);

            if(params.pk){
                getCanhotos(params.pk);
            }  
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);              
        }
    }

    async function urltoFile(url: string, filename: string, mimeType: string){
        return (fetch(url)
            .then(function(res){return res.arrayBuffer();})
            .then(function(buf){return new File([buf], filename,{type:mimeType});})
        );
    }

    const updateCanhoto = async () => {    
        try{
            setLoading(true);

            const target = document.querySelector('#update') as HTMLInputElement;
            if (!target) return;

            //var arquivo: File = (target.files as FileList)[0];
            var arquivo = null
            if(!arquivo){
                const blob = await urltoFile(imagem.value, 'image.jpg', 'image/jpeg')
                arquivo = new File([blob], 'image.jpg');
            }
            console.log(arquivo)
            //return ;
            const bodyFormData = new FormData();
            bodyFormData.append('file', arquivo);
            bodyFormData.append('PKControleDeFreteMov', pk.value);
            bodyFormData.append('TimeStamp', timestamp.value);
            bodyFormData.append('Action2Do', '2');
            bodyFormData.append('PKControleDeFrete', params.pk);
            bodyFormData.append('PKTransportadora', params.pktransportadora);
            bodyFormData.append('TipoConhecimento', tipo_conhecimento.value);
            bodyFormData.append('TipoDocumento', tipo_documento.value);
            bodyFormData.append('SeqDoc', seq_doc.value ? seq_doc.value : '');
            bodyFormData.append('NumeroDocumento', num_doc.value ? num_doc.value : '');
            bodyFormData.append('Filial', filial.value);
            bodyFormData.append('NumeroNF', numero_nfe.value);
            bodyFormData.append('Serie', serie_nfe.value);
            bodyFormData.append('DataEntrega', data_entrega.value ? data_entrega.value : '');

            bodyFormData.append('Valor', valor.value !== 'undefined' ? valor.value.replace(/[^0-9,]*/g, '').replace(',', '.') : '');

            const headers = {headers: {"Content-Type": "multipart/form-data"}}

            await api.post('/frete/canhoto/save', bodyFormData, headers);

            setSuccess('Atualizado com sucesso!');
            setSendActive(true);
            setOpen(false);
            setImage(null);

            if(params.pk){
                getCanhotos(params.pk);
            }  
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);         
            handleCloseConfirmCode();     
        } 
    }

    const deleteCanhoto = async () => {    
        try{
            if (!canhoto) return;

            setLoading(true);
           
            const blob = await urltoFile(imagem.value, 'image.jpg', 'image/jpeg')
            const arquivo = new File([blob], 'image.jpg');
            
            const bodyFormData = new FormData();
            bodyFormData.append('file', arquivo);
            bodyFormData.append('PKControleDeFreteMov', canhoto.PK);
            bodyFormData.append('TimeStamp', canhoto.TimeStamp);
            bodyFormData.append('Action2Do', '3');
            bodyFormData.append('PKControleDeFrete', params.pk);
            bodyFormData.append('PKTransportadora', params.pktransportadora);
            bodyFormData.append('TipoConhecimento', canhoto.iTipoConhecimento);
            bodyFormData.append('TipoDocumento', canhoto.iTipoDocumento);
            bodyFormData.append('SeqDoc', canhoto.iSeqDoc ? canhoto.iSeqDoc : '');
            bodyFormData.append('NumeroDocumento', canhoto.iNumeroDocumento ? canhoto.iNumeroDocumento : '');
            bodyFormData.append('Filial', canhoto.sFilial);
            bodyFormData.append('NumeroNF', canhoto.iNumeroNF);
            bodyFormData.append('Serie', canhoto.sSerie);
            bodyFormData.append('DataEntrega', canhoto.dtDataEntrega);

            const cleanValue = canhoto.nValor.toString().replace(/[^0-9,]*/g, '').replace(',', '.');
            bodyFormData.append('Valor', cleanValue);

            const headers = {headers: {"Content-Type": "multipart/form-data"}}

            await api.post('/frete/canhoto/save', bodyFormData, headers);

            setSuccess('Deletado com sucesso!');
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);

            if(params.pk){
                getCanhotos(params.pk);
            }    
        } 
    }

    const handleCloseConfirmCode = () => {
        setOpenConfirmCode(false);
    }    

    const handleUpdate = () => {
        updateCanhoto();        
    }

    const handleConfirmBack = () => {
        setConfirmBack(false);
    }

    const handleBack = () => {
        if(sendActive){
            setConfirmBack(true);
        }else{
            navigate(`${process.env.PUBLIC_URL}/usuario/controle-de-frete`);
        }
    }

    const handleMessageSuccess = () => {
        setSuccess('')
    }

    const handleMessageError = () => {
        setError('')
    }

    const n = 5; // Or something else

    return (
        <Container>              
            <Header>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.button}
                    startIcon={<ArrowBackIcon/>}
                    onClick={handleBack}
                >
                    VOLTAR
                </Button> 
                <Hr/>
                <div>
                    <Document className="shadow">
                        <div><p><span className="bold">ID:</span><br/>{documentoPai?.PK}</p></div>      
                        <div style={{minWidth: '350px'}}>
                            <p>
                                <span className="bold">Situação:</span><br/>
                                {documentoPai?.iSituacao === '1' && <AlertMaterialUI style={{width: '100%'}} severity="warning">{documentoPai?.sDescSituacao}</AlertMaterialUI>}
                                {documentoPai?.iSituacao === '2' && <AlertMaterialUI style={{width: '100%'}} severity="warning" iconMapping={{ warning: <TimerIcon fontSize="inherit" /> }}>{documentoPai?.sDescSituacao}</AlertMaterialUI>}
                                {documentoPai?.iSituacao === '3' && <AlertMaterialUI style={{width: '100%'}} severity="error">{documentoPai?.sDescSituacao}</AlertMaterialUI>}
                                {documentoPai?.iSituacao === '4' && <AlertMaterialUI style={{width: '100%'}} severity="success">{documentoPai?.sDescSituacao}</AlertMaterialUI>}
                            </p>
                        </div>
                        <div style={{minWidth: '350px'}}>
                            <p>
                                <span className="bold">Situação Envio:</span><br/>
                                {documentoPai?.iSituacaoEnvio === '1' && <AlertMaterialUI style={{width: '100%'}} severity="warning">{documentoPai?.sDescSituacaoEnvio}</AlertMaterialUI>}
                                {documentoPai?.iSituacaoEnvio === '2' && <AlertMaterialUI style={{width: '100%'}} severity="success">{documentoPai?.sDescSituacaoEnvio}</AlertMaterialUI>}
                            </p>
                        </div>                        
                        <div><p><span className="bold">Tipo:</span><br/>{tipoDocumentoStr}</p></div>
                        {params.tipo === '1' && <div><p><span className="bold">CTE:</span><br/>{documentoPai?.sChaveCTe}</p></div>}
                        <div><p><span className="bold">Numero:</span><br/>{documentoPai?.iNumero}</p></div>
                        <div><p><span className="bold">Série:</span><br/>{documentoPai?.sSerie}</p></div>
                        <div><p><span className="bold">Emissão:</span><br/>{moment(documentoPai?.dtDataEmissao).format('DD/MM/YYYY')}</p></div>                                                 
                        <div><p><span className="bold">QTD:</span><br/>{documentoPai?.iQtdeCanhotos}</p></div>
                        <div><p><span className="bold">Valor Total:</span><br/>{formatter.format(parseFloat(`${documentoPai?.nValorTotal}`))}</p></div>
                        <div><p><span className="bold">Data Cadastro:</span><br/>{moment(documentoPai?.dtUsoarioCadastro).format('DD/MM/YYYY')}</p></div>
                    </Document>
                </div>   
            </Header>                
            <AlertDark style={{marginTop: 10}} severity="info">
                <div className="ds-flex al-items-center">
                    <p>Assim que terminar de enviar todos os canhotos, clique no Menu (<ListIcon style={{position: 'relative', top: '8'}}/> ) no canto inferior direito, e então clique em Finalizar Envio.</p>
                </div>
            </AlertDark>         
            <ContainerItem>       
                {
                    canhotos.slice(inicioPage * canhotosPorPagina, inicioPage * canhotosPorPagina + canhotosPorPagina).map(( item, index ) => (
                        <Item key={index} className="align-items-center shadow">
                            <div>
                                <Image>
                                    <div className="count">
                                        <span>{page > 1 ? (index + 1) + inicioPage * canhotosPorPagina : (index + 1)}</span>
                                    </div>
                                    {item.sNomeArquivo ? <img alt="sNomeArquivom Canhoto" title="Imagem Canhoto" src={`${item.imgDocumento}`}/> :  '120x120'}
                                    <div className="capa" onClick={() => handleClickOpenImage(item)}>
                                        <CgMaximize size={23}/>
                                    </div>
                                </Image>                        
                            </div>   
                            <ItemInfo className="ds-flex align-items-center space-between flex">
                                <div>
                                    <h2>{item.iNumeroNF}</h2> 
                                    <h3>Valor: {formatter.format(parseFloat(item.nValor))}</h3>
                                    <p>Data de Entrega: <br/>{item.dtDataEntrega ? moment(item.dtDataEntrega).format('DD/MM/YYYY h:mm:ss a') : 'Não Informado'}</p>                       
                                </div>
                                <div>
                                    <h3>Status</h3>
                                    {item.iSituacao === '1' ?
                                        <AlertMaterialUI severity="warning">
                                            {item.sDescSituacao}
                                        </AlertMaterialUI>
                                    : item.iSituacao === '2' ? 
                                        <AlertMaterialUI severity="error" iconMapping={{ success: <CheckCircleOutlineIcon/> }}>
                                            {item.sDescSituacao}
                                        </AlertMaterialUI>
                                    :
                                        <AlertMaterialUI severity="success" iconMapping={{ success: <CheckCircleOutlineIcon/> }}>
                                            {item.sDescSituacao}
                                        </AlertMaterialUI>
                                    }                                   
                                </div>
                                <div className="ds-flex">
                                    <div onClick={() => handleClickOpenView(item)} className="svg pointer">
                                        <AiFillEye color={"#666"} size={20}/>
                                    </div>  
                                    {(item.iSituacaoEnvio !== '2') && 
                                        <div onClick={() => handleClickOpen(item)} className="svg pointer">
                                            <GrEdit size={20}/>
                                        </div>   
                                    }
                                    {(params.tipo === '3' || params.tipo === '4') && 
                                        <div onClick={() => handleConfirm(item)} className="svg pointer">
                                            <RiDeleteBin5Line color={"#be2323"} size={20}/>
                                        </div> 
                                    }                                    
                                </div>                                  
                            </ItemInfo>                                
                        </Item>  
                    ))
                }  
                {(canhotos.length === 0 && params.pk && loading) &&                   
                    [...Array(n)].map((e, i) => (
                        <div key={i}>
                            <Skeleton style={{marginBottom: 10}} variant="rect" height={118}/>                           
                        </div>  
                    ))
                }    
                {canhotos.length === 0 &&                   
                    <Empty>
                        <h1 className="centro">Sem registros, clique no icone <ListIcon style={{position: 'relative', top: '8', fill: '#000'}}/> no canto inferior direito para mais opções.</h1>                        
                    </Empty>
                }  
                {canhotos.length > 0 &&
                    <div className={classes.root}>
                        <Pagination count={Math.ceil(canhotos.length / canhotosPorPagina)} size="large" page={page} onChange={handleChangePagination}/>
                    </div>   
                }                                                                                   
            </ContainerItem>   

            <Modal 
                open={openConfirm} 
                onClose={handleCloseConfirmDelete} 
                onConfirm={handleClickDelete} 
                titleModal={"Excluir Canhoto"}
                message={"Você está prestar a Excluir um canhoto!! Tem certeza que deseja continuar com essa ação ?"}
                textConfirm={"EXCLUIR"}
            />

            <Modal 
                open={confirmBack} 
                onClose={handleConfirmBack} 
                onConfirm={() => navigate(`${process.env.PUBLIC_URL}/usuario/controle-de-frete`)} 
                titleModal={"Deseja sair sem salvar ?"}
                message={"Você está saindo sem finalizar o envio! Deseja continuar ?"}
                textConfirm={"SAIR"}
            />
           
            <Dialog
                open={openConfirmCode}
                onClose={handleCloseConfirmCode}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <MuiDialogTitle id="alert-dialog-title">{"Confirmar NFe"}</MuiDialogTitle>
                <DialogContent>
                    <img title="Imagem" alt="Imagem" src={!image ? `${imagem.value}` : `${image}`}/>
                    <DialogContentText>
                        Digite abaixo o numero da NFe presente na <strong style={{color: '#000'}}>IMAGEM ACIMA</strong>:
                    </DialogContentText>
                    <Input 
                        label="Confirme o Numero da NFe: " 
                        id="code_confirm" 
                        type="number" 
                        {...code_confirm}
                    />  
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmCode} color="primary">
                        CANCELAR
                    </Button>
                    <Button disabled={code_confirm.value !== numero_nfe.value} onClick={handleUpdate} color="primary" autoFocus>
                        CONFIRMAR
                    </Button>
                </DialogActions>
            </Dialog> 

            <Modal 
                open={openSend} 
                onClose={handleConfirmationSendOrCancel} 
                onConfirm={situacaoDocument} 
                titleModal={canhotos.length > 0 && canhotos[0].iSituacaoEnvio === '1' ? "Enviar" : "Cancelar Envio"}
                message={`Clicando em "CONFIRMAR" você está 
                        ${canhotos.length > 0 && canhotos[0].iSituacaoEnvio === '1' ? " enviando todos os registros para que o setor financeiro faça a analise dos mesmos." : " cancelando o envio."}
                `}
            />

            <Modal 
                open={open} 
                onClose={() => {setOpen(false);setShowCroppie(false)} } 
                onConfirm={() => {handleCloseEdit();setShowCroppie(false)} } 
                titleModal={"Editar Canhoto"}               
                fullWidth 
                fullScreen={fullScreen}
                textConfirm="EDITAR"
            >   

                        <CroppieI>
                            <Button
                                variant="text"
                                color="default"
                                size="small"
                                className={classes.button}
                                startIcon={<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M12.29,5.21l1.5,1.5a1,1,0,0,0,1.42,0,1,1,0,0,0,.13-1.21H19a1,1,0,0,0,0-2H15.34a1,1,0,0,0-.13-1.21,1,1,0,0,0-1.42,0l-1.5,1.5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76A1,1,0,0,0,12.29,5.21ZM22.92,9.12a1,1,0,0,0-.21-.33l-1.5-1.5a1,1,0,0,0-1.42,0,1,1,0,0,0-.13,1.21H16a1,1,0,0,0,0,2h3.66a1,1,0,0,0,.13,1.21,1,1,0,0,0,1.42,0l1.5-1.5a1,1,0,0,0,.21-.33A1,1,0,0,0,22.92,9.12ZM11,10a4,4,0,1,0,4,4A4,4,0,0,0,11,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,11,16Zm9-3a1,1,0,0,0-1,1v5a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H6a1,1,0,0,0,1-.69l.54-1.62A1,1,0,0,1,8.44,7H10a1,1,0,0,0,0-2H8.44A3,3,0,0,0,5.59,7.06L5.28,8H4a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V14A1,1,0,0,0,20,13Z"/></svg>}
                            >
                                <LabelI htmlFor="update" >Carregar Imagem</LabelI>
                            </Button>  

                            <Upload onInput={() => {LoadCroppie(); console.log('input')} } onChange={uploadFile} id="update" accept="image/jpeg" type="file"/>

                            <div id="image-helper" className={showCroppie ? 'croppie-container' : 'hidden'}></div>
                            
                            <Button
                                variant="outlined"
                                color="default"
                                size="small"
                                className={showCroppie ? classes.button : 'hidden'}
                                onClick={handleSubmit}
                            >
                                Confirmar
                            </Button>  
                            
                        </CroppieI>

                        
                        {
                        (image || imagem.value) ? 
                            <div>
                                <img alt="Imagem do Canhoto" title="Imagem do Canhoto" src={image ? `${image}` : `${imagem.value}`}/>
                            </div>
                        : 
                            <div className="capa capa-hover">
                                {/* <FaCamera size={30}/> */}
                                <p>Sem Imagem</p>
                                <div>
                                    <span>Formato: JPG</span>
                                </div>
                            </div>
                        }
                        
                                                                  
                <Select 
                    label="Tipo Conhecimento: " 
                    required
                    id="tipo_conhecimento" 
                    {...tipo_conhecimento} 
                    options={tipoConhecimento}
                />

                <Select 
                    label="Tipo Documento: " 
                    required
                    id="tipo_documento" 
                    {...tipo_documento} 
                    options={tipoDocumento}
                />                            
                <Select 
                    label="Filial: " 
                    required
                    id="filial" 
                    {...filial} 
                    options={filiais}
                    disabled={['1', '2'].includes(params.tipo)}
                />    
                <DsFlex>   
                    <Input 
                        label="Numero NFe: " 
                        required id="numero_nfe" 
                        type="number" 
                        {...numero_nfe}
                        disabled={['1', '2'].includes(params.tipo)}
                    />
                    <Input 
                        label="Série NFe: " 
                        maxLength={3} 
                        required 
                        id="valor" 
                        type="number" 
                        {...serie_nfe}
                        disabled={['1', '2'].includes(params.tipo)}
                    />
                </DsFlex>                                          
                <Input label="Data Entrega: " required id="data" type="date" {...data_entrega}/>
                <Label htmlFor="valor">Valor: </Label>
                <NumberFormat
                    type="text"
                    value={valor.value}
                    customInput={Input}
                    onValueChange={(values) => {
                        const {formattedValue} = values;
                        valor.setValue(formattedValue);
                    }}
                    format={currencyFormatter}
                />
                <DsFlex>                                                                 
                    <Input 
                        label="Seq. Doc.: " 
                        disabled={!['2', '3'].includes(tipo_conhecimento.value)} 
                        id="seq_doc" 
                        type="number" 
                        {...seq_doc}
                    />         
                    <Input 
                        label="Nº Doc: " 
                        disabled={!['2', '3'].includes(tipo_conhecimento.value)} 
                        id="num_doc" 
                        type="number" 
                        {...num_doc}
                    />  
                </DsFlex>
            </Modal>

            <Modal 
                open={openAdd} 
                onClose={() => setOpenAdd(false)} 
                onConfirm={handleCloseAdd} 
                titleModal={"Adicionar Canhoto"}               
                fullWidth 
                fullScreen={fullScreen}
                textConfirm="SALVAR"
            >
                <CroppieI>
                    <Button
                        variant="text"
                        color="default"
                        size="small"
                        className={classes.button}
                        startIcon={<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M12.29,5.21l1.5,1.5a1,1,0,0,0,1.42,0,1,1,0,0,0,.13-1.21H19a1,1,0,0,0,0-2H15.34a1,1,0,0,0-.13-1.21,1,1,0,0,0-1.42,0l-1.5,1.5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76A1,1,0,0,0,12.29,5.21ZM22.92,9.12a1,1,0,0,0-.21-.33l-1.5-1.5a1,1,0,0,0-1.42,0,1,1,0,0,0-.13,1.21H16a1,1,0,0,0,0,2h3.66a1,1,0,0,0,.13,1.21,1,1,0,0,0,1.42,0l1.5-1.5a1,1,0,0,0,.21-.33A1,1,0,0,0,22.92,9.12ZM11,10a4,4,0,1,0,4,4A4,4,0,0,0,11,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,11,16Zm9-3a1,1,0,0,0-1,1v5a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H6a1,1,0,0,0,1-.69l.54-1.62A1,1,0,0,1,8.44,7H10a1,1,0,0,0,0-2H8.44A3,3,0,0,0,5.59,7.06L5.28,8H4a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V14A1,1,0,0,0,20,13Z"/></svg>}
                    >
                        <LabelI htmlFor="send" >Carregar Imagem</LabelI>
                    </Button>  

                    <Upload onInput={() => {LoadCroppie(); console.log('input')} } onChange={uploadFile} id="send" accept="image/jpeg" type="file"/>

                    <div id="image-helper" className={showCroppie ? 'croppie-container' : 'hidden'}></div>
                    
                    <Button
                        variant="outlined"
                        color="default"
                        size="small"
                        className={showCroppie ? classes.button : 'hidden'}
                        onClick={handleSubmit}
                    >
                        Confirmar
                    </Button>  
                </CroppieI>

                <div className="ds-flex justify-content-center">
                    <Image>
                        {image ?
                            <img alt="Imagem do Canhoto" title="Imagem do Canhoto" src={`${image}`}/>
                        :
                            <div className="capa capa-hover">
                                <FaCamera size={30}/>
                                <div>
                                    <span>Formato: JPG</span>
                                </div>
                            </div>
                        }
                        {/** <Upload onChange={uploadFile} id="send" accept="image/jpeg" type="file"/> */}
                    </Image>  
                </div>            
                <Select label="Tipo Conhecimento: " required
                        id="tipo_conhecimento" {...tipo_conhecimento} options={tipoConhecimento}/>   
                <Select label="Tipo Documento: " required
                        id="tipo_documento" {...tipo_documento} options={tipoDocumento}/>                           
                <Select 
                    label="Filial: " 
                    required
                    id="filial" 
                    {...filial} 
                    options={filiais}
                    disabled={['1', '2'].includes(params.tipo)}
                />    
                <DsFlex>   
                    <Input 
                        label="Numero NFe: " 
                        required id="numero_nfe" 
                        type="number" 
                        {...numero_nfe}
                        disabled={['1', '2'].includes(params.tipo)}
                    />
                    <Input 
                        label="Série NFe: " 
                        maxLength={3} 
                        required id="valor" 
                        type="number" 
                        {...serie_nfe}
                        disabled={['1', '2'].includes(params.tipo)}
                    />
                </DsFlex>                                          
                <Input label="Data Entrega: " required id="data" type="date" {...data_entrega}/>
                <Label htmlFor="valor">Valor: </Label>
                <NumberFormat
                    type="text"
                    value={valor.value}
                    customInput={Input}
                    onValueChange={(values) => {
                        const {formattedValue} = values;
                        valor.setValue(formattedValue);
                    }}
                    format={currencyFormatter}
                />
                <DsFlex>                                                                 
                    <Input label="Seq. Doc.: " disabled={!['2', '3'].includes(tipo_conhecimento.value)} id="seq_doc" type="number" {...seq_doc}/>         
                    <Input label="Nº Doc: " disabled={!['2', '3'].includes(tipo_conhecimento.value)} id="num_doc" type="number" {...num_doc}/>  
                </DsFlex> 
            </Modal>      
            
            <Modal 
                open={openImage} 
                onClose={handleCloseImage} 
                titleModal={"Imagem Canhoto"} 
                fullWidth 
                fullScreen={fullScreen}              
            >   
                {canhoto?.imgDocumento ? 
                    <img alt="Imagem Canhoto" title="Imagem Canhoto" src={`${canhoto.imgDocumento}`}/>
                :
                    <h1 className="centro">Imagem não enviada</h1>
                }
            </Modal>           

            <Modal 
                open={openView} 
                onClose={handleCloseView} 
                titleModal={"Visualizar Canhoto"} 
                fullWidth 
                fullScreen={fullScreen}              
            >   
                {canhoto &&
                    <>
                        <div className="ds-flex justify-content-center">
                            <Image>
                                {canhoto?.imgDocumento && <img alt="Imagem do Canhoto" title="Imagem do Canhoto" src={`${canhoto?.imgDocumento}`}/>}
                                {canhoto &&
                                    <div className="capa" onClick={() => handleClickOpenImage(canhoto)}>
                                        <CgMaximize size={23}/>
                                    </div>
                                }
                            </Image>                        
                        </div>                        
                        <p><strong>PK</strong>: {canhoto?.PK}</p>
                        <p><strong>Filial</strong>: {canhoto?.sFilial}</p>
                        <p><strong>NumeroNF</strong>: {canhoto?.iNumeroNF}</p>
                        <p><strong>Serie</strong>: {canhoto?.sSerie}</p>
                        <p><strong>Data de Entrega</strong>: {moment(canhoto?.dtDataEntrega).format('DD/MM/YYYY h:mm:ss a')}</p>
                        <p><strong>Valor</strong>: {formatter.format(parseFloat(canhoto.nValor))}</p>
                        {canhoto.iServidorArquivo && <p><strong>iSeqDoc</strong>: {canhoto?.iSeqDoc}</p>}
                        {canhoto.iNumeroDocumento && <p><strong>iNumeroDocumento</strong>: {canhoto?.iNumeroDocumento}</p>}
                        {canhoto.nValorPago &&  <p><strong>Valor Pago</strong>: {formatter.format(canhoto.nValorPago)}</p>}
                        {canhoto.iServidorArquivo && <p><strong>Servidor Arquivo</strong>: {canhoto?.iServidorArquivo}</p>}
                        {canhoto.sUsoarioAtualizou && <p><strong>Usuário que atualizou</strong>: {canhoto?.sUsoarioAtualizou}</p>}
                        {canhoto.dtUsoarioAtualizou && <p><strong>Última atualização em</strong>: {moment(canhoto.dtUsoarioAtualizou).format('DD/MM/YYYY h:mm:ss a')}</p>}
                        <p><strong>Data do Cadastro</strong>: {moment(canhoto?.dtUsoarioCadastro).format('DD/MM/YYYY h:mm:ss a')}</p>
                        <p><strong>Usuário que realizou o cadastro</strong>: {canhoto?.sUsoarioCadastro}</p>
                        <p><strong>NF</strong>: {canhoto?.iNF}</p>
                        <Hr />
                        <p><strong>Situação</strong></p>
                        {canhoto.iSituacao === '1' ?
                            <AlertMaterialUI severity="warning" iconMapping={{ warning: <TimerIcon fontSize="inherit" /> }}>
                                {canhoto.sDescSituacao}
                            </AlertMaterialUI>
                        : canhoto.iSituacao === '2' ? 
                            <AlertMaterialUI severity="error" iconMapping={{ success: <CheckCircleOutlineIcon fontSize="inherit" /> }}>
                                {canhoto.sDescSituacao}
                            </AlertMaterialUI>
                        :
                            <AlertMaterialUI severity="success" iconMapping={{ success: <CheckCircleOutlineIcon fontSize="inherit" /> }}>
                                {canhoto.sDescSituacao}
                            </AlertMaterialUI>
                        }  
                    </>
                }   
            </Modal>

            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>
           
            <Backdrop open={openSpeed} className={classes.rootSpeed}/>

            {documentoPai?.iSituacao !== '4' &&
                <SpeedDial
                    ariaLabel="SpeedDial tooltip example"
                    className={classes.speedDial}
                    icon={<ListIcon />}
                    onClose={handleCloseSpeed}
                    onClick={handleOpenSpeedDial}
                    open={openSpeed}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            key={action.name}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            tooltipOpen
                            onClick={(e) => {
                                handleOptionsSpeedDial(e, action.operation)
                            }}
                        />
                    ))}
                </SpeedDial>    
            }                                                                                         
        </Container>
    );
};

export default Anexar;